import { I18nProvider } from './i18n-provider';
import { QueryProvider } from './query-provider';
import { TronProvider } from './tron-provider';
import { AppUIProvider } from './ui-provider';
import { WagmiProvider } from './wagmi-provider';

interface AppProvidersProps {
  children: React.ReactNode;
}

export function AppProviders({ children }: AppProvidersProps) {
  return (
    <I18nProvider>
      <QueryProvider>
        <WagmiProvider>
          <TronProvider>
            <AppUIProvider>{children}</AppUIProvider>
          </TronProvider>
        </WagmiProvider>
      </QueryProvider>
    </I18nProvider>
  );
}
